import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useToast, useAuth, usePage, usePopup } from "@/comn/hooks"; // hook
import {
    URLS,
    APIS,
    SF_LPCO_FEE_MDFY_DTL_SRCH,
    SF_LPCO_FEE_MDFY_DTL,
    SF_LPCO_FEE_MDFY,
    SG_BLL_ITM_LIST,
} from "@/tz/go/egaz/osci/lpco/fee/services/OsciLpcoFeeService";
import { APIS_COMN, SF_COMN_TANSAD_INFO } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Fee Modification Request Registration
 * !== 수수료 변경 신청 등록 (OSCI_LPCO_FEE_MDFY_R/ITM_R 기준) ==!
 */
export const OSCI0205011S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0009", "auth_osci0021", "auth_osci0003"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams();
    const { mode } = useParams();

    // 폼 처리
    const [isVisibleBll, setIsVisibleBll] = useState(false);
    const [isVisibleMdfy, setIsVisibleMdfy] = useState(false);

    // grid 그리기
    const [vsdItms, setVsdItms] = useState(false);

    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    // 버튼 처리
    const [isVisibleSaveBtn, setIsVisibleSaveBtn] = useState(false);
    const [isTzs, setTzs] = useState(true);
    const [exrt, setExrt] = useState();
    const [curMdfyRqstSn, setCurMdfyRqstSn] = useState<any>(undefined);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Fee Modification Request Detail Search !== 수수료 변경 신청 상세 조회 ==!
        bllUpdtDtlSrch: useForm({
            defaultSchema: SF_LPCO_FEE_MDFY_DTL_SRCH,
            defaultValues: {
                bllMgmtId: bllMgmtId,
            },
        }),
        // Fee Modification Request Detail  !== 수수료 변경 신청 상세 폼 ==!
        bllUpdtDtl: useForm({
            defaultSchema: SF_LPCO_FEE_MDFY_DTL,
        }),
        // Common TANSAD Info  !== 공통 TANSAD정보 폼 ==!
        comnTansadInfo: useForm({
            defaultSchema: SF_COMN_TANSAD_INFO,
        }),
        // Fee Modification Request  !== 수수료 변경 신청 등록 폼 ==!
        mdfyForm: useForm({
            defaultSchema: SF_LPCO_FEE_MDFY,
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    /*
     * USD -> TZS 환산 헬퍼 (환율 exrt 기준)
     * !== OSCI0205008S usdToTzs 이식 ==!
     */
    const usdToTzs = (usd: any) => {
        if (!usd || !exrt) return 0;
        return Number((usd * exrt).toFixed(2));
    };

    /*
     * 통화별 편집 가능 토글
     * !== isTzs === true : TZS 통화 / false : USD 통화 (OSCI0205008S readyCurr 이식) ==!
     */
    const readyCurr = (_isTzs: boolean) => {
        if (_isTzs) {
            // TZS : TZS 금액 입력, USD 금액 readonly
            form.bllUpdtDtl.setSchema("feeAmt", { edit: false });
            form.bllUpdtDtl.setSchema("feeTzsAmt", { edit: true });
        } else {
            // USD : USD 금액 입력, TZS 금액은 환산(readonly)
            form.bllUpdtDtl.setSchema("feeAmt", { edit: true });
            form.bllUpdtDtl.setSchema("feeTzsAmt", { edit: false });
        }
    };

    const readyEdit = (bllUpdtDtl: any) => {
        // 통화 판별 후 편집가능 필드 토글 (USD 아니면 TZS)
        const _isTzs = bllUpdtDtl.currCd !== "USD";
        setTzs(_isTzs);
        if (bllUpdtDtl.exrt) {
            setExrt(bllUpdtDtl.exrt);
            form.bllUpdtDtl.setValue("exrt", bllUpdtDtl.exrt);
        }

        readyCurr(_isTzs);
        form.bllUpdtDtl.setSchema("payDdlnDt", { edit: true });
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getExchageRate: useFetch({
            api: (data) => {
                return APIS.getExchageRate(data);
            },
            enabled: true,
            onSuccess: (data) => {
                if (!data.exrt.content || data.exrt.content === 0) {
                    modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
                } else {
                    setExrt(data.exrt.content);
                    form.bllUpdtDtl.setValue("exrt", data.exrt.content);
                }
            },
            onError: (error) => {
                modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
            },
        }),
        // Get Fee Modification Request Detail !== 수수료 변경 신청 상세 조회 ==!
        getBllUpdtDtl: useFetch({
            api: (bllMgmtId) => APIS.getBllUpdtDtl(form.bllUpdtDtlSrch.getValues()),
            onSuccess: (data) => {
                const bllUpdtDtl = data.bllUpdtDtl.content;
                if (!bllUpdtDtl?.bllMgmtId) {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                    return;
                }

                const orgCd = auth.get("orgCd");

                // 소속 기관 bill이 아닌 경우
                if (bllUpdtDtl?.orgCd !== orgCd) {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                    return;
                }

                // 통합고지서의 상세 건인 경우 (GRP_BLL_MGMT_ID가 자신의 BLL_MGMT_ID와 다르면 통합고지서 소속)
                if (bllUpdtDtl?.grpBllMgmtId && bllUpdtDtl.grpBllMgmtId !== bllUpdtDtl?.bllMgmtId) {
                    modal.openModal({
                        content: "msg.osc.00322", // Combined bills cannot be adjusted.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleMdfy(false);
                    return;
                }

                // 컨트롤번호가 없는 경우
                if (!bllUpdtDtl?.ctrlNo) {
                    modal.openModal({
                        content: "msg.osc.00268", // There is no information sent to Revenue Gateway. The Notice cannot be canceled.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleMdfy(false);
                    return;
                }

                if (mode === "INSERT" && (bllUpdtDtl?.mdfyStatCd === "R" || bllUpdtDtl?.mdfyStatCd === "S")) {
                    modal.openModal({
                        content: t("msg.osc.00103", { 0: t("L_BLL_NO") }), //{0} was already registered.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleMdfy(false);
                    return;
                }

                // 이미 납부된 경우
                if (bllUpdtDtl?.bllStatCd == "C") {
                    modal.openModal({
                        content: "msg.osc.00321", // Payment received. Fee adjustment is not allowed.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleMdfy(false);
                    return;
                }

                // 이미 취소된 경우
                if (bllUpdtDtl?.bllStatCd == "F") {
                    modal.openModal({
                        content: "msg.osc.00167", // Notice has already been cancelled.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleMdfy(false);
                    return;
                }

                // form 데이터 세팅
                form.bllUpdtDtl.setValues({
                    ...bllUpdtDtl,
                });

                setCurMdfyRqstSn(bllUpdtDtl?.mdfyRqstSn);
                readyEdit(bllUpdtDtl);

                setIsVisibleBll(true);
                setIsVisibleMdfy(true);

                // Taxpayer TIN
                let pyerMgmtNoNm = "";
                if (bllUpdtDtl?.pyerMgmtNo == null || bllUpdtDtl?.pyerNm == null) {
                    if (bllUpdtDtl?.pyerMgmtNo != null) {
                        pyerMgmtNoNm = bllUpdtDtl?.pyerMgmtNo;
                    } else if (bllUpdtDtl?.pyerNm != null) {
                        pyerMgmtNoNm = bllUpdtDtl?.pyerNm;
                    }
                } else {
                    pyerMgmtNoNm = bllUpdtDtl?.pyerMgmtNo + ", " + bllUpdtDtl?.pyerNm;
                }
                form.bllUpdtDtl.setValue("pyerMgmtNoNm", pyerMgmtNoNm);

                // Reference Key
                if (bllUpdtDtl.reffKeyTpCd && bllUpdtDtl.reffKeyTpCd === "T") {
                    let reffKeyNo =
                        bllUpdtDtl?.reffKeyNo1 +
                        "-" +
                        bllUpdtDtl?.reffKeyNo2 +
                        (bllUpdtDtl?.reffKeyNo3 ? "-" + bllUpdtDtl?.reffKeyNo3 : "") +
                        (bllUpdtDtl?.reffKeyNo4 ? "-" + bllUpdtDtl?.reffKeyNo4 : "");
                    form.bllUpdtDtl.setValue("reffKey", reffKeyNo);
                } else {
                    let reffKeyNo = bllUpdtDtl?.reffKeyNo1;
                    form.bllUpdtDtl.setValue("reffKey", reffKeyNo);
                }

                // Register
                form.bllUpdtDtl.setValue("bllRgsrIdNm", bllUpdtDtl?.bllRgsrId + ", " + bllUpdtDtl?.bllRgsrNm);

                // 이미 고지 재사용 등록 된 경우 (레거시 REUS 값을 참고로만 채워둔다)
                if (bllUpdtDtl.mdfyStatCd === "S") {
                    form.mdfyForm.setValue("mdfyRsnCd", bllUpdtDtl?.mdfyRsnCd);
                    form.mdfyForm.setValue("mdfyRmrk", bllUpdtDtl?.mdfyRmrk);
                    if (mode == "INSERT") {
                        form.mdfyForm.setEditable(false);
                        setIsVisibleSaveBtn(false);
                    } else if (mode == "UPDATE") {
                        form.mdfyForm.setEditable(true);
                        setIsVisibleSaveBtn(true);
                    }
                } else {
                    form.mdfyForm.setValue("mdfyRsnCd", bllUpdtDtl?.mdfyRsnCd);
                    form.mdfyForm.setValue("mdfyRmrk", bllUpdtDtl?.mdfyRmrk);
                    form.mdfyForm.setEditable(true);
                    setIsVisibleSaveBtn(true);
                }

                if (data.bllUpdtDtl.content.bllItms && data.bllUpdtDtl.content.bllItms.length > 0) {
                    setVsdItms(true);
                    setBllItmList(comnUtils.getGridData(data.bllUpdtDtl.content.bllItms));
                }

                form.bllUpdtDtlSrch.setValues({
                    ...data.bllUpdtDtl.content,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Save Fee Modification Request !== 수수료 변경 신청 저장 ==!
        saveLpcoFeeMdfy: useFetch({
            api: (dtlData, mdfyData, mode) => APIS.saveLpcoFeeMdfy(dtlData, mdfyData, mode),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", // 성공적으로 처리 되었습니다.
                    onClose: () => {
                        let bllMgmtId = form.bllUpdtDtlSrch.getValue("bllMgmtId");
                        navigate(`${URLS.osci0205010q}/${bllMgmtId}`);
                        // mode == "INSERT" ? navigate(`${URLS.osci0403004q}`) : navigate(`${URLS.osci0403005q}/${bllNo}`);
                    },
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    console.log(error.response.data);
                }
                modal.openModal({
                    content: "msg.osc.00015", // 처리중 문제가 발생하였습니다.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Fee Modification Request Registration Detail !== 수수료 변경 신청 등록 상세 조회 ==!
        getBllReusRgsrDtl: () => {
            form.bllUpdtDtlSrch.handleSubmit(
                () => {
                    let bllNo = form.bllUpdtDtlSrch.getValue("bllNo");

                    if (bllNo) {
                        bllNo = bllNo.trim(); // 앞뒤 공백 제거

                        // "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거
                        if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(bllNo)) {
                            bllNo = bllNo.replaceAll("-", "");
                        }

                        form.bllUpdtDtlSrch.setValue("bllNo", bllNo); // 정규화된 값을 폼에 반영
                    }
                    let bllTpCd = form.bllUpdtDtlSrch.getValue("bllTpCd");
                    let bllSysmCd = form.bllUpdtDtlSrch.getValue("bllSysmCd");
                    let bllYy = form.bllUpdtDtlSrch.getValue("bllYy");
                    let bllSrno = form.bllUpdtDtlSrch.getValue("bllSrno");
                    let bllDgr = form.bllUpdtDtlSrch.getValue("bllDgr");
                    let bllMgmtIdSrch = form.bllUpdtDtlSrch.getValue("bllMgmtId");
                    if (
                        !!!bllNo &&
                        !!!bllMgmtIdSrch &&
                        (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)
                    ) {
                        modal.openModal({
                            content: "msg.osc.00182", // Please check Bill No.
                        });
                        setIsVisibleBll(false);
                        setIsVisibleMdfy(false);
                        return false;
                    }
                    fetch.getBllUpdtDtl.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // 데이터가 유효하지 않습니다.
                },
            )();
        },
        // Save Fee Modification Request !== 수수료 변경 신청 저장 ==!
        saveLpcoFeeMdfy: form.mdfyForm.handleSubmit(
            () => {
                let valid = true;
                const dtlData = { ...form.bllUpdtDtl.getValues() };
                const mdfyData = {
                    ...form.mdfyForm.getValues(),
                    exrt: exrt,
                    mdfyRsnCd: "A",
                    mdfyRqstSn: mode === "UPDATE" ? curMdfyRqstSn : undefined,
                };

                const itmGridData = grid.bllItmList.getData();

                // 1. 활성 통화 기준 합계 계산 (TZS : feeTzsAmt / USD : feeAmt)
                const totAmt = Number(isTzs ? dtlData.feeTzsAmt || 0 : dtlData.feeAmt || 0);

                // 일반고지서 : 총액 = 품목금액 합계 (활성 통화 기준)
                const totalItmAmt = (itmGridData || []).reduce(
                    (sum: number, itm: any) => sum + Number(isTzs ? itm.bllItmTzsAmt || 0 : itm.bllItmAmt || 0),
                    0,
                );

                if (totAmt !== totalItmAmt) {
                    const msg = t("msg.osc.00054", { 0: "the item amounts." });
                    modal.openModal({ content: msg });
                    valid = false;
                }
                const today = new Date();
                const payDdlnDate = new Date(dtlData.payDdlnDt);
                if (valid && payDdlnDate < today) {
                    const msg = t("msg.osc.00313"); // The payment due date must be set to a date after today.
                    modal.openModal({ content: msg });
                    valid = false;
                }

                if (valid) {
                    // 일반고지서 : 상세고지서 bllMgmtId = 고지서 bllMgmtId, top form 금액을 단일 상세에 반영
                    const dtlList = dtlData.bllDtls;
                    if (dtlList && dtlList.length > 0) {
                        dtlList.forEach((dtl: any) => {
                            dtl.feeAmt = dtlData.feeAmt;
                            dtl.feeTzsAmt = dtlData.feeTzsAmt;
                        });
                    }

                    const itmList = dtlData.bllItms;

                    itmList.forEach((itm: any) => {
                        const gridItem = itmGridData.find(
                            (item) => item.bllMgmtId === itm.bllMgmtId && item.gfsCd === itm.gfsCd,
                        );
                        if (gridItem) {
                            itm.bllItmAmt = gridItem.bllItmAmt;
                            itm.bllItmTzsAmt = gridItem.bllItmTzsAmt;
                        }
                    });

                    console.log("==============================================");
                    console.log(dtlData);

                    modal.openModal({
                        content: "msg.osc.00090", // 저장 하시겠습니까 ?
                        onConfirm: () => {
                            fetch.saveLpcoFeeMdfy.fetch(dtlData, mdfyData, mode);
                        },
                    });
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    const render = {
        grid_bllItmList: {
            head: {},
            cell: {
                // 항목 USD 금액 : USD 통화일 때만 입력, 입력 시 TZS 자동 환산
                bllItmAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmAmt}
                                onChange={(v) => {
                                    !isTzs &&
                                        grid.bllItmList.updateRow({
                                            ...rowValues,
                                            bllItmAmt: v,
                                            bllItmTzsAmt: usdToTzs(v),
                                        });
                                }}
                                edit={!isTzs}
                                required={true}
                            />
                        </>
                    );
                },
                // 항목 TZS 금액 : TZS 통화일 때만 입력, USD 칸은 동일값
                bllItmTzsAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmTzsAmt}
                                onChange={(v) => {
                                    isTzs &&
                                        grid.bllItmList.updateRow({
                                            ...rowValues,
                                            bllItmAmt: v,
                                            bllItmTzsAmt: v,
                                        });
                                }}
                                edit={isTzs}
                                required={true}
                            />
                        </>
                    );
                },
            },
            edit: {},
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        if (mode == "UPDATE") {
            handler.getBllReusRgsrDtl();
            form.bllUpdtDtlSrch.setEditable(false);
        }
        form.comnTansadInfo.setEditable(false);
        form.bllUpdtDtl.setEditable(false);
        // 통화 확정 전에는 두 금액 필드 모두 잠금 → 조회 onSuccess 의 readyCurr(_isTzs)에서 통화별로 제어
        form.bllUpdtDtl.setSchema("feeAmt", { edit: false });
        form.bllUpdtDtl.setSchema("feeTzsAmt", { edit: false });
    }, []);

    useEffect(() => {
        if (!isVisibleMdfy) return;
        readyCurr(isTzs);

        if (isTzs) {
            // TZS: 환산액 = 원금
            const feeAmt = form.bllUpdtDtl.getValue("feeAmt");
            form.bllUpdtDtl.setValue("feeTzsAmt", feeAmt);
            grid.bllItmList
                .getData()
                .forEach((row: any) => grid.bllItmList.updateRow({ ...row, bllItmTzsAmt: row.bllItmAmt }));
        } else {
            // USD: 현재 exrt로 재환산
            const feeAmt = form.bllUpdtDtl.getValue("feeAmt");
            form.bllUpdtDtl.setValue("feeTzsAmt", usdToTzs(feeAmt));
            grid.bllItmList
                .getData()
                .forEach((row: any) => grid.bllItmList.updateRow({ ...row, bllItmTzsAmt: usdToTzs(row.bllItmAmt) }));
        }
    }, [isTzs, exrt]);

    return (
        <Page>
            {/* 수수료 변경 신청 상세 조회 */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllUpdtDtlSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllUpdtDtlSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Col>
                                {/* 고지번호 */}
                                <Group.Control
                                    {...form.bllUpdtDtlSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllUpdtDtlSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllUpdtDtlSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllUpdtDtlSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllUpdtDtlSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllUpdtDtlSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllUpdtDtlSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllUpdtDtlSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllUpdtDtlSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllUpdtDtlSrch.schema.bllDgr} />
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>
                    {mode == "INSERT" && (
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllUpdtDtlSrch.reset();
                                        setIsVisibleBll(false);
                                        form.bllUpdtDtl.reset();
                                        form.comnTansadInfo.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllReusRgsrDtl();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
            {/* 고지 상세내역 */}
            {isVisibleBll && (
                <>
                    {/* Bill */}
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllUpdtDtl.schema.bllNo} />
                                    <Group.Control {...form.bllUpdtDtl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllUpdtDtl.schema.ctrlNo} />
                                    <Group.Control {...form.bllUpdtDtl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllUpdtDtl.schema.currCd} />
                                    <Group.Control {...form.bllUpdtDtl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control
                                        {...form.bllUpdtDtl.schema.feeAmt}
                                        onChange={(v: any) => {
                                            // USD : 입력값 x 환율로 TZS 자동 환산
                                            if (!isTzs) {
                                                form.bllUpdtDtl.setValue("feeTzsAmt", usdToTzs(v));
                                            }
                                        }}
                                    />
                                    <Group.Control
                                        {...form.bllUpdtDtl.schema.feeTzsAmt}
                                        onChange={(v: any) => {
                                            // TZS : USD 칸은 동일값 저장
                                            if (isTzs) {
                                                form.bllUpdtDtl.setValue("feeAmt", v);
                                            }
                                        }}
                                    />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllUpdtDtl.schema.pyerMgmtNo} />
                                    <Group.Control {...form.bllUpdtDtl.schema.payDdlnDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Col label="L_REFF_KEY">
                                        {form.bllUpdtDtl.getValue("reffKey") && (
                                            <>
                                                <Group.Control {...form.bllUpdtDtl.schema.reffKeyTpCd} />
                                                <Group.Any> : </Group.Any>
                                                <Group.Control {...form.bllUpdtDtl.schema.reffKey} />
                                            </>
                                        )}
                                    </Group.Col>
                                    <Group.Control {...form.bllUpdtDtl.schema.bllRgsrId} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </>
            )}
            {vsdItms && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                    </Group.Body>
                </Group>
            )}
            {/* 수수료 변경 신청 등록 */}
            {isVisibleMdfy && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.mdfyForm.schema.mdfyRmrk} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0205009q);
                        }}
                    ></Button>
                </Layout.Left>
                {isVisibleSaveBtn && (
                    <Layout.Right>
                        <Button
                            role="save"
                            onClick={() => {
                                handler.saveLpcoFeeMdfy();
                            }}
                        ></Button>
                    </Layout.Right>
                )}
            </Layout>
        </Page>
    );
};
